export default {
    languages: [
      {
        text: "English-US",
        value: "en-US",
      },
      {
        text: "English-India",
        value: "en-IN",
      },
      {
        text: "Spanish",
        value: "es",
      },
      {
        text: "Indonesian",
        value: "in",
      },
      {
        text: "French",
        value: "fr",
      },
      {
        text: "Portuguese",
        value: "pt",
      },
      {
        text: "Arabic",
        value: "ar-u-nu-arab",
      },
      {
        text: "Russian",
        value: "ru",
      },
      {
        text: "Italian",
        value: "it",
      },
      {
        text: "German",
        value: "de",
      },
      {
        text: "Polish",
        value: "pl",
      },
      {
        text: "Turkey",
        value: "tr",
      },
      {
        text: "Tamil",
        value: "ta",
      },
      {
        text: "Hindi",
        value: "hi",
      },
      {
        text: "Bengali",
        value: "bn",
      },
      {
        text: "Gujrati",
        value: "gu",
      },
      {
        text: "Hebrew",
        value: "he",
      },
      {
        text: "Japanese",
        value: "ja",
      },
      {
        text: "Kannada",
        value: "kn",
      },
      {
        text: "Korean",
        value: "ko",
      },
      {
        text: "Malayalam",
        value: "ml",
      },
      {
        text: "Punjabi",
        value: "pa",
      },
      {
        text: "Telugu",
        value: "te",
      },
      {
        text: "Thai",
        value: "te",
      },
      {
        text: "Vietnamese",
        value: "vi",
      },
      {
        text: "Chinese",
        value: "zh",
      },
    ],}